module.exports = __webpack_public_path__ + "img/full6-min.6d998c6e.png";